import { getInstance } from './instance';

const logToSentry = (error: Error, errorInfo?: Record<string, any>) => {
  console.error(error, errorInfo);
  getInstance()?.captureException(error, (scope) => {
    const { level, ...extras } = errorInfo || {};
    if (level) {
      scope.setLevel(level);
    }
    Object.keys(extras).forEach((key) => {
      scope.setExtra(key, extras[key]);
    });
    return scope;
  });
};

export default logToSentry;
